import { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { LocationEnum, Quest as QuestType } from '@/types'
import { QUESTS } from '@/constants/quests'
import { useGameplayContext } from '@/contexts/gameplayContext'

import { Quest } from '../shared/Quest'

const questsData = QUESTS

export function QuestsScreen() {
  const [showCompleted, setShowCompleted] = useState(false)
  const { gameData } = useGameplayContext()

  const activeMainQuest = gameData.activeMainQuest && questsData[gameData.activeMainQuest]
  const activeSideQuests = Object.values(questsData).filter(
    (quest) =>
      quest.type === 'side' &&
      quest.location === gameData.currentLocation &&
      !gameData.completedQuests.includes(quest.key)
  )
  const activeQuests = []
  if (gameData.activeMainQuest && activeMainQuest) {
    activeQuests.push(activeMainQuest)
  }
  if (activeSideQuests.length > 0) {
    activeQuests.push(activeSideQuests[0])
  }

  const completedQuests = Object.values(questsData).filter((quest) => gameData.completedQuests.includes(quest.key))

  return (
    <div className="space-y-6">
      <h2 className="text-3xl font-bold text-white drop-shadow-md">Quests 🎯</h2>

      <div className="bg-white rounded-lg shadow-lg p-4">
        <h3 className="text-xl font-semibold mb-4">Active Quests</h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {activeQuests.map((quest, index) => (
            <Quest key={index} quest={quest as QuestType} />
          ))}
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Completed Quests</h3>
          <button
            onClick={() => setShowCompleted(!showCompleted)}
            className="flex items-center text-purple-500 hover:text-purple-700"
          >
            {showCompleted ? (
              <>
                Hide <ChevronUp className="ml-1" />
              </>
            ) : (
              <>
                Show <ChevronDown className="ml-1" />
              </>
            )}
          </button>
        </div>
        {showCompleted && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {completedQuests.map((quest, index) => (
              <Quest key={index} quest={quest as QuestType} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
